export const DESIGNATION_REQUEST = "DESIGNATION_REQUEST";
export const DESIGNATION_SUCCESS = "DESIGNATION_SUCCESS";
export const DESIGNATION_FAIL = "DESIGNATION_FAIL"